import type { A2UIRouteData, A2UIRouteKind } from '@/a2ui/serverData';
import { loadA2UIRouteData } from '@/serverDataFn';

export async function loadTypedA2UIRouteData<TKind extends A2UIRouteKind>(pathname: string, expectedKind: TKind): Promise<Extract<A2UIRouteData, { kind: TKind }>> {
  const data = (await loadA2UIRouteData({ data: pathname })) as A2UIRouteData;
  if (data.kind !== expectedKind) throw new Error(`Unexpected A2UI route data kind for ${pathname}: ${data.kind}`);
  return data as Extract<A2UIRouteData, { kind: TKind }>;
}
